export enum ObjectCacheKey {
  PAGE = 'Page',
  PRODUCT = 'Product',
  HEADER = 'Header',
  FOOTER = 'Footer',
}

export const generateObjectCacheKey = (
  cacheKey: ObjectCacheKey,
  value?: string,
) => `${cacheKey}${value ? `:${value}` : ''}`
